"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recreateWithTotalForValueGroup = void 0;
const number_1 = require("@project-rouge/service-core/data/number");
const value_index_1 = require("../data/value-index");
/**
 * Recreate the value group collection and total all values.
 */
const recreateWithTotalForValueGroup = (grouping) => {
    const output = [];
    for (const x of grouping) {
        const total = (0, number_1.toPrecision)(x.items.reduce((total, item) => item.value + total, 0), 2);
        const group = {
            index: x.index,
            items: x.items,
            total,
        };
        group.items.sort(value_index_1.sortValueGroupIndexFunction);
        output.push(group);
    }
    output.sort(value_index_1.sortValueGroupIndexFunction);
    return output;
};
exports.recreateWithTotalForValueGroup = recreateWithTotalForValueGroup;
